const baseUrl = process.env.REACT_APP_API_BASE_URL as string;
const version = process.env.REACT_APP_API_VERSION as string;
const appUrl = process.env.React_App_Base_URL as string;
const blobUrl = process.env.REACT_APP_BLOB_IMAGE_URL as string;

export const API_URL = `${baseUrl}/${version}`;
export const BASE_URL = appUrl;
export const SIGNALR_BASE_URL = process.env.REACT_APP_SIGNALR_BASE_URL;

export const BLOB_IMAGE_URL = blobUrl;

export const environment = process.env.REACT_APP_ENV as string;

export const abcPgUrl = process.env.REACT_APP_ABC_PG_URL;
export const abcCryptoUrl = process.env.REACT_APP_ABC_CRYPTO_URL;
export const abcAppId = process.env.REACT_APP_ABC_APPID;
export const abcCryptoAppId = process.env.REACT_APP_ABC_CRYPTO_APPID;
export const abcUtrAppId = process.env.REACT_APP_ABC_UTR_APPID;
export const abcUtrTwoAppId = process.env.REACT_APP_ABC_UTR_TWO_APPID;
export const abcUtrThreeAppId = process.env.REACT_APP_ABC_UTR_THREE_APPID;
export const abcUtrFourAppId = process.env.REACT_APP_ABC_UTR_FOUR_APPID;
export const abcNonUtrTwoAppId = process.env.REACT_APP_ABC_NON_UTR_TWO_APPID;
export const abcUtrFiveAppid = process.env.REACT_APP_ABC_UTR_FIVE_APPID;
